/**
 * Date-extensions locale Maori [mi]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('mi', {
    monthNames: ['Kohi-tāte','Hui-tanguru','Poutū-te-rangi','Paenga-whāwhā','Haratua','Pipiri','Hōngoingoi','Here-turi-kōkā','Mahuru','Whiringa-ā-nuku','Whiringa-ā-rangi','Hakihea'],
    monthShortNames: ['Kohi','Hui','Pou','Pae','Hara','Pipi','Hōngoi','Here','Mahu','Whi-nu','Whi-ra','Haki'],
    dayNames: ['Rātapu','Mane','Tūrei','Wenerei','Tāite','Paraire','Hātarei'],
    dayShortNames: ['Ta','Ma','Tū','We','Tāi','Pa','Hā']
});
